/*
 * Pufien — yorumcu adı (V3, 10 Ekim 2026). layout/theme.liquid her sayfada yükler.
 * İçe aktarılan yorumların yorumcu adı Judge.me'de "Anonymous". Gerçek ad verisi olmadığı için ad ÜRETİLMEZ;
 * adı "Anonymous"/"Anonim" olan yorumda profil satırı (avatar + ad) gizlenir. Yıldız, tarih, metin ve fotoğraf görünür.
 * Gerçek adı olan site yorumları aynı kalır. Judge.me sonradan yorum yüklerse de yakalanır.
 */
(function () {
  if (window.__pfYorumIsim) return;
  window.__pfYorumIsim = true;
  var GIZLE = { anonymous: 1, anonim: 1 };
  var SEC = '.jdgm-rev__author, .jdgm-carousel-item__reviewer-name, .jdgm-rev-widg__author, .jdgm-gallery__reviewer-name, .jdgm-all-reviews__author';
  function duzelt(kok) {
    if (!kok || !kok.querySelectorAll) return;
    var liste = kok.matches && kok.matches(SEC) ? [kok] : kok.querySelectorAll(SEC);
    for (var i = 0; i < liste.length; i++) {
      var el = liste[i];
      var ad = (el.textContent || '').trim().toLowerCase();
      if (el.childElementCount === 0 && GIZLE[ad]) {
        var satir = el.closest('.jdgm-row-profile') || el.closest('.jdgm-rev__author-wrapper') || el;
        satir.style.display = 'none';
      }
    }
  }
  function basla() {
    duzelt(document);
    new MutationObserver(function (kayitlar) {
      for (var i = 0; i < kayitlar.length; i++) {
        var eklenen = kayitlar[i].addedNodes;
        for (var j = 0; j < eklenen.length; j++) if (eklenen[j].nodeType === 1) duzelt(eklenen[j]);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();
})();
